import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("Create New Author")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = !_ctx.modal)),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            class: "btn btn-primary"
          }, "Save")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Author Full Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "social-title",
            class: _normalizeClass([{'is-invalid':!_ctx.validation.full_name}, "form-control"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.full_name) = $event)),
            required: "",
            maxlength: "75"
          }, null, 2), [
            [_vModelText, _ctx.full_name]
          ]),
          (!_ctx.validation.full_name)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, "A Name is Required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Biosketch", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass([{'is-invalid':!_ctx.validation.biosketch}, "form-control"]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.biosketch) = $event)),
            maxlength: "500",
            required: "",
            rows: "6"
          }, null, 2), [
            [_vModelText, _ctx.biosketch]
          ]),
          (!_ctx.validation.biosketch)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "A biosketch is required"))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}